var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2757_22874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 9V12",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12H26C26.5304 12 27.0391 12.2107 27.4142 12.5858C27.7893 12.9609 28 13.4696 28 14V16.9163C28 19.0963 26.2912 20.9388 24.1125 20.9988C23.5779 21.0138 23.0458 20.9215 22.5475 20.7273C22.0492 20.5331 21.5949 20.241 21.2115 19.8681C20.8281 19.4953 20.5233 19.0494 20.3152 18.5568C20.1071 18.0641 20 17.5348 20 17C20 18.0609 19.5786 19.0783 18.8284 19.8284C18.0783 20.5786 17.0609 21 16 21C14.9391 21 13.9217 20.5786 13.1716 19.8284C12.4214 19.0783 12 18.0609 12 17C12.0002 17.5349 11.8931 18.0644 11.6851 18.5572C11.4771 19.05 11.1724 19.496 10.7889 19.869C10.4055 20.2419 9.95117 20.5342 9.4528 20.7284C8.95444 20.9227 8.42218 21.015 7.8875 21C5.70875 20.9387 4 19.0963 4 16.9163V14C4 13.4696 4.21071 12.9609 4.58579 12.5858C4.96086 12.2107 5.46957 12 6 12Z",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 19.6125V25C27 25.5304 26.7893 26.0391 26.4142 26.4142C26.0391 26.7893 25.5304 27 25 27H7C6.46957 27 5.96086 26.7893 5.58579 26.4142C5.21071 26.0391 5 25.5304 5 25V19.6125",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6C19 6.79565 18.6839 7.55871 18.1213 8.12132C17.5587 8.68393 16.7956 9 16 9C15.2044 9 14.4413 8.68393 13.8787 8.12132C13.3161 7.55871 13 6.79565 13 6C13 3 16 1 16 1C16 1 19 3 19 6Z",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2757_22874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/Birthday.00d4e35cbfa0e4d4f44c45db54b4dc47.svg";
export { ForwardRef as ReactComponent };